module.exports = __webpack_public_path__ + "media/site_templates/www.end-of-lease-cleaner.com.au/images/testimonials-3cdf40f911aa6127a426e9ed5c79d9de.jpg";